import Vue from 'vue'
import VueRouter from 'vue-router'
import mantenimiento from '../views/Mantenimiento.vue'
import prueba from '../views/PruebaTerminada.vue'
import ofa from '../views/OFA.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/mantenimiento/:num',
    name: 'mantenimiento',
    component: mantenimiento
  },
  {
    path: '/prueba/:num',
    name: 'prueba',
    component: prueba
  },

{
    path: '/ofa/:num',
    name: 'ofa',
    component: ofa
  },]

const router = new VueRouter({
  routes
})

export default router
